import { API_URL, authenticatedFetch } from "../config/api";

export const getProjectDailyUpdates = async (_token: string, project_id: string, options?: { archived?: boolean; page?: number; size?: number }): Promise<ProjectDailyUpdatesInterface> => {
  try {
    const url = new URL(`${API_URL}/projects/${project_id}/daily-update`);
    const size = options?.size ?? 1000;
    const page = options?.page ?? 1;
    url.searchParams.set('size', String(size));
    url.searchParams.set('page', String(page));
    if (options?.archived) {
      url.searchParams.set('archived', 'true');
    }
    const r = await authenticatedFetch(url.toString());
    const data:ProjectDailyUpdatesInterface = await r.json();

    return data;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};

export const getProjectDailyUpdatesById = async (_token: string, project_id: string, record_id: string): Promise<ProjectDailyUpdate> => {
  try {
    const r = await authenticatedFetch(`${API_URL}/projects/${project_id}/daily-update/${record_id}`);
    const data:any = await r.json();

    return data;
  } catch(e: Error | any) {
    throw new Error(e);
  }
}

export const createProjectDailyUpdates = async (_token: string, project_id: string, data: ProjectDailyUpdate): Promise<ProjectDailyUpdate> => {
  try {
    const r = await authenticatedFetch(`${API_URL}/projects/${project_id}/daily-update`,{
      method: 'POST',
      body: JSON.stringify(data)
    })
    if (!r.ok) {
      throw new Error(r.statusText);
    }

    const res:any = await r.json();

    return res;
  } catch(e: Error | any) {
    throw new Error(e);
  }
}

export const updateProjectDailyUpdates = async (_token: string, project_id: string, record_id: string, data: ProjectDailyUpdate): Promise<any> => {
  try {
    const res = await authenticatedFetch(`${API_URL}/projects/${project_id}/daily-update/${record_id}`,{
      method: 'PUT',
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      throw new Error(res.statusText);
    }
    

    return res;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};

export const deleteProjectDailyUpdates = async (_token: string, project_id: string, record_id: string): Promise<ProjectDailyUpdate> => {
  try {
    const r = await authenticatedFetch(`${API_URL}/projects/${project_id}/daily-update/${record_id}`,{
      method: 'DELETE'
    })
    const res:any = await r.json();

    return res;
  } catch(e: Error | any) {
    throw new Error(e);
  }
};
